import React, { Component } from "react";
import jwt_decode from "jwt-decode";
import AxiosLibWithHeader2 from "../../../Library/AxiosLibWithHeader2";
import { Academic } from "./Widget";
import { Link } from "react-router-dom";
import Notifications from "./Widget/Notifications";
import CardAppStore from "./Widget/CardAppStore";
import { NotifAnnouncement } from "./NotifAnnouncements";
import AxiosLib from "../../../Library/AxiosLib";
import Invoice from "./Widget/Invoice";
import WProgressProfile from "./Widget/WProgressProfile";
import { CardPCFShortcut } from "../Reregistration-New/Components/PCFUI";
import MyCalendars from "./Widget/Calendars/MyCalendars";

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.fetchingAnnouncements = this.fetchingAnnouncements.bind(this);
    this.GET_ACTIVE_ACAD = this.GET_ACTIVE_ACAD.bind(this);
    this.getIsPCFOpen = this.getIsPCFOpen.bind(this);
    console.log("param:",props);

    var AuthToken = localStorage.getItem("AuthToken");
    const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];
    this.state = {
      AuthDecode: AuthDecode,
      StudentData:props?.student ||"",
      Acad: [],
      SemesterStatus: [],
      Expired: [],
      LoadingPage: false,
      BannedUser: [],
      IsError: false,
      ErrorMsg: "",
      ISPCF: false,
      isShortSemes:false,
      itemAnnouncement: JSON.parse(
        localStorage.getItem("announcement") || "[]"
      ),
      announcements: { loading: false, message: "", data: [] },
    };
  }

  fetchingAnnouncements(param) {
    try {
      this.setState({
        announcements: { loading: true, message: "", data: [] },
      });
      AxiosLib(param, "mc/api/notifications/active").then((response) => {
        console.log("ini:",response);
        if (response.error) {
          this.setState({
            announcements: { loading: false, message: "", data: [] },
          });
          localStorage.setItem("announcement", "[]");
        } else {
          if (response.data) {
            localStorage.setItem("announcement", JSON.stringify(response.data));
            this.setState({
              announcements: {
                loading: false,
                message: "",
                data: response.data,
              },
            });
          } else {
            localStorage.setItem("announcement", "[]");
            this.setState({
              announcements: { loading: false, message: "", data: [] },
            });
          }
        }
      });
    } catch (error) {
      console.error("Error fetching announcements:", error);
    }
  }


  getIsPCFOpen(target_data) {
    this.setState({ LoadingPage: true });
    var keys = {
      AppId: this.state.AuthDecode.AppID,
      AppEnv: this.state.AuthDecode.AppEnv,
      Secretkey: this.state.AuthDecode.secretkey,
    };
    var body = {
      parameters: {
        studentid: this.state.AuthDecode.currentData.entityid,
      },
      target_data: target_data || "GET_REREG_STUDENT",
    };
    const postData = {
      keys: keys,
      body: body,
    };

    AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
      if (response.error) {
        this.setState({ IsError: true, LoadingPage: false });
      } else if ("message" in response.response) {
        this.setState({
          MessageRereg: response.response.message,
          LoadingPage: false,
        });
      } else {
        console.log(response.response.data);
        if (response.response.data) {
          console.log("open");
          this.setState({
            ISPCF: true,
          });
        } else {
          this.setState({
            LoadingPage: false,
          });
        }
      }
    });
  }

  GET_ACTIVE_ACAD() {
    var keys = {
      AppId: this.state.AuthDecode.AppID,
      AppEnv: this.state.AuthDecode.AppEnv,
      Secretkey: this.state.AuthDecode.secretkey,
    };
    var body = {
      target_data: "GET_ACTIVE_ACAD",
    };
    const postData = {
      keys: keys,
      body: body,
    };

    AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
      if (response.error) {
        this.setState({
          IsError: true,
          ErrorMsg: response.error,
          LoadingPage: false,
        });
      } else if ("message" in response.response) {
        var msg = response.response.message.user;
        this.setState({
          IsError: true,
          ErrorMsg: msg,
          LoadingPage: false,
        });
      } else {
        var results = response.response.data;
        if (results) {
          this.setState({ Acad: results, LoadingPage: false });
          const findTypeCal = results.find(item => item?.atp_group_type?.id === this.state.StudentData?.atp_group_type);
          const findShortSemesCal = findTypeCal?.reff_atp_term?.atp_type.includes("short") ? true : false;
          if(findShortSemesCal){
            this.setState({isShortSemes:true});
            this.getIsPCFOpen("GET_REREG_STUDENT_SS");
          }else{
            this.setState({isShortSemes:false});
            this.getIsPCFOpen("GET_REREG_STUDENT");
          }
        } else {
          this.setState({
            IsError: true,
            ErrorMsg: "No record found for Academic Calendar",
            LoadingPage: false,
          });
        }
      }
    });
  }

  componentDidMount() {
    this.GET_ACTIVE_ACAD();
    if (this.state.itemAnnouncement.length > 0) {
      this.setState({
        announcements: {
          loading: false,
          message: "",
          data: this.state.itemAnnouncement,
        },
      });
    } else {
      this.fetchingAnnouncements({
        Roles: this.state.AuthDecode.currentData.roleid,
      });
    }
  }

  render() {
    if (Object.keys(this.state.Expired).length > 0) {
      return (
        <div className="container-fluid">
          <div className="alert alert-danger">
            <p className="m-0">
              <h1>You've been signed out</h1>
              <p>{this.state.Expired.user}</p>
              <p className="text-center">
                <Link to={{ pathname: "/sign-out" }} className="btn btn-light">
                  Re-Sign in here
                </Link>
              </p>
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <div className="col-lg-8">
            <MyCalendars student={this.state.StudentData} />
            <div className="row">
              <div className="col-lg-6">
                <Invoice />
              </div>
              <div className="col-lg-6">
                <CardAppStore />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="mb-5">
              {this.state.ISPCF === true && (
                <CardPCFShortcut title={`PCF ${this.state.isShortSemes ? 'Short Semester' : 'Registration'}`} />
              )}
              {Object.values(this.state.StudentData).length > 0 &&
                this.state.ISPCF && this.state.ISPCF === true && (
                  <Notifications
                    stdstatus={this.state.StudentData}
                    exept={3}
                  />
              )}
              {Object.values(this.state.announcements.data).length > 0 && (
                <NotifAnnouncement data={this.state.announcements.data} />
              )}

              {Object.values(this.state.StudentData).length > 0 && (
                <>
                  <Academic data={this.state.StudentData} />
                  <div className="mt-5">
                    <WProgressProfile student={this.state.StudentData} />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Dashboard;
